import { render, staticRenderFns } from "./OnboardingDetail.vue?vue&type=template&id=758bccc8&"
import script from "./OnboardingDetail.vue?vue&type=script&lang=ts&"
export * from "./OnboardingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingDetail.vue?vue&type=style&index=0&id=758bccc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports